export const OFFSET_LIMIT_PAGINATION = 10;

export const BUTTON_TEXT = 'Показать ещё';
